import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=68efe91c&"
import script from "./Snackbar.vue?vue&type=script&lang=ts&"
export * from "./Snackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/iwata/Documents/Project/SMILE-AYA/dev/smileaya-admin-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VBtn,VSnackbar})
